import React from 'react';
import { Link, useParams } from 'react-router-dom';
import '../styles/BlogPost.css';

const BlogPostPage = () => {
  const { slug } = useParams();
  const blogPosts = [
    {
      id: 1,
      title: 'Thinking of selling your property?',
      content: `
        <p>A well-planned renovation can significantly boost your home's value and attract more buyers. Here are some strategic upgrades to maximize your return on investment (ROI) before listing your property.</p>

        <h3>1. Refresh with a Fresh Coat of Paint 🎨</h3>
        <p>A fresh coat of neutral-colored paint (such as white, beige, or light gray) instantly brightens up your home, making it look newer and more inviting. This simple update is one of the most cost-effective ways to enhance your property's appeal.</p>

        <h3>2. Upgrade Your Kitchen for Maximum Impact 🍽️</h3>
        <p>The kitchen is often the heart of the home, and a modern, functional kitchen can greatly influence buyers. Consider:</p>
        <ul>
          <li>Replacing old cabinet handles and faucets for a sleek look</li>
          <li>Upgrading countertops to quartz or granite</li>
          <li>Installing energy-efficient appliances</li>
        </ul>
        <p>Even minor upgrades can make your kitchen stand out without breaking the bank!</p>

        <h3>3. Bathroom Makeover: Small Changes, Big Difference 🛁</h3>
        <p>A clean, modern bathroom is a major selling point. You don’t need a complete remodel—simple fixes like:</p>
        <ul>
          <li>Replacing outdated fixtures</li>
          <li>Regrouting tiles</li>
          <li>Adding a stylish mirror</li>
          <li>Installing a rain shower</li>
        </ul>
        <p>These updates can make your bathroom look fresh and luxurious.</p>

        <h3>4. Improve Flooring for an Instant Upgrade 🏡</h3>
        <p>Floors set the tone for your entire home. If your tiles or wooden flooring look worn out, consider refinishing or replacing them. Vinyl flooring is an affordable option that gives a modern and polished look.</p>

        <h3>5. Enhance Curb Appeal: First Impressions Matter! 🌿</h3>
        <p>The exterior of your property is the first thing buyers see. Enhance your curb appeal by:</p>
        <ul>
          <li>Cleaning and maintaining the landscaping</li>
          <li>Repainting the front door</li>
          <li>Updating outdoor lighting</li>
        </ul>
        <p>A welcoming entrance can make buyers fall in love with your property at first sight!</p>

        <h3>6. Maximize Natural Light ☀️</h3>
        <p>Bright, well-lit homes feel more spacious and inviting. To enhance natural light:</p>
        <ul>
          <li>Replace heavy curtains with sheer ones</li>
          <li>Clean windows and remove obstructions</li>
          <li>Use mirrors to reflect light and make rooms appear bigger</li>
        </ul>

        <h3>7. Declutter & Depersonalize for a Showroom Look 🏠</h3>
        <p>Buyers need to envision themselves in your home. Remove personal items, excess furniture, and unnecessary décor to create a clean, spacious feel. A clutter-free space looks larger and more attractive.</p>

        <h3>8. Fix Minor Repairs 🛠️</h3>
        <p>Don’t let small issues turn buyers away! Address minor repairs such as:</p>
        <ul>
          <li>Leaky faucets</li>
          <li>Cracked tiles</li>
          <li>Peeling paint</li>
          <li>Loose door handles</li>
        </ul>
        <p>These minor fixes prevent buyers from negotiating for a lower price.</p>

        <h3>9. Upgrade Smart Home Features 📱</h3>
        <p>Modern buyers love tech! Installing smart features like digital door locks, smart lighting, or energy-efficient air conditioning can add perceived value to your home.</p>

        <h3>10. Stage Your Home for a Lasting Impression 🎭</h3>
        <p>Home staging can make a huge difference in how buyers perceive your property. Arrange furniture strategically, add fresh flowers, and use soft lighting to create a cozy and inviting atmosphere.</p>

        <h3>Final Thoughts 💡</h3>
        <p>You don’t need to break the bank to make a big impact. A few strategic renovations can significantly boost your home’s value and help it sell faster. Want more property tips? Follow me for the latest insights on Singapore real estate!</p>
      `,
      image: 'blog1.png', // Ensure the image is in the assets folder
      date: 'February 17, 2025',
      slug: 'top-renovation-tips',
    },
    // Add more blog posts here
  ];

  const post = blogPosts.find((post) => post.slug === slug);

  if (!post) {
    return <div>Post not found</div>;
  }

  return (
  <div>
    <img src={require(`../assets/${post.image}`)} alt={post.title} className='postImage' />
      <section className='section-narrow'>
          <h1>{post.title}</h1>
          <p className='postDate'>{post.date}</p>
          <div
            className='postContent'
            dangerouslySetInnerHTML={{ __html: post.content }} // Render HTML content
          />
          <Link to='/blog' className='backToBlogButton'>
            Back to Blog
          </Link>
      </section>
    </div>
  );
};

export default BlogPostPage;